import SketchfabWrapper from './SketchfabWrapper.js';

var Camera = {
    loopTimeoutIndex: null,
    inPano: false,
    panoLookat: [0,0,0], //the position of the current pano
    panoDistance: 8,

    GetCameraAngle: function(camera) {
        //get the up/down angle a camera is making
        var targetPos = camera.target;
        var camPos = camera.position;
        var deltaZ = targetPos[2]-camPos[2]
        var zoomDistance = Camera.distanceVector(camPos,targetPos);
        var camAngle = Math.asin(deltaZ/zoomDistance)
        return camAngle;
    },

    EnforceMinCameraAngle: function(api) {
        //enforce a minimum camera angle depending on the zoom distance and
        //target height. formula by Carste Schonart
        //minAngle = asin (orbitcentreheight/zoomdistance)
        api.getCameraLookAt( function( err, camera ){
            var targetPos = camera.target;
            var camPos = camera.position;
            var camPosOnGroundlevel = [camPos[0],camPos[1],0];
            var zoomDistance = Camera.distanceVector(camPosOnGroundlevel,targetPos);
            var minAngle = Math.asin(camera.target[2]/zoomDistance)
            // console.log('minAngle',minAngle);
            var camAngle = Camera.GetCameraAngle(camera);
            // console.log('camAngle',camAngle);

            //enforce the min angle
            if (camAngle > minAngle) {
                // var relativeCam = [targetPos[0]-camPos[0],targetPos[1]-camPos[1],targetPos[2]-camPos[2]];
                var relativeCam = [camPos[0]-targetPos[0],camPos[1]-targetPos[1],camPos[2]-targetPos[2]];
                // console.log('relativeCam',relativeCam);
                //calculate the angle in the xy plane
                var gamma = Math.atan(relativeCam[0]/relativeCam[1])
                if (relativeCam[1] < 0){
                    gamma = Math.PI + gamma;
                }
                if (relativeCam[1] > 0 && relativeCam[0] < 0){
                    gamma = 2 * Math.PI + gamma;
                }
                // console.log('gamma',gamma);
                // var gammaDeg = gamma * (180/Math.PI);
                // console.log('gammaDeg',gammaDeg);

                var S = Camera.distanceVector(camPos,targetPos)
                var Sxy = Math.sqrt(S*S-targetPos[2]*targetPos[2])
                // var S = Math.sqrt(relativeCam[0]*relativeCam[0]+relativeCam[1]*relativeCam[1]+relativeCam[2]*relativeCam[2])
                // console.log('S',S);
                // console.log('Sxy',Sxy);
                var x = Sxy * Math.sin(gamma);
                var Y = Sxy * Math.cos(gamma);
                // console.log('X',x);
                // console.log('Y',Y);
                var newPos = [x+targetPos[0],Y+targetPos[1],0]
                Camera.SetCamera(api,newPos,camera.target);
            };
        });
    },

    LockPano: function(distance){
        //locking a camera for a pano means
        //locking the lookat
        //locking the distance between eye and lookat
        SketchfabWrapper.api.getCameraLookAt( function( err, camera ){
            // console.log('camera',camera);


            var camPos = camera.position;
            var targetPos = camera.target;
            var zoomDistance = Camera.distanceVector(camPos,targetPos);
            //enforce the maximum distance
            if (zoomDistance !== Camera.panoDistance) {
                //start at the target location and set the camera back to its maximum
                //distance
                var factor = Camera.panoDistance / zoomDistance
                var newCamPos = [0,0,0]
                newCamPos[0] = Camera.panoLookat[0] + (camPos[0]-Camera.panoLookat[0])*factor
                newCamPos[1] = Camera.panoLookat[1] + (camPos[1]-Camera.panoLookat[1])*factor
                newCamPos[2] = Camera.panoLookat[2] + (camPos[2]-Camera.panoLookat[2])*factor
                SketchfabWrapper.api.setCameraLookAt( newCamPos,Camera.panoLookat,0.01 );
            }else{
                //if we're still within range, we just reset the target. This is effectively
                //blocking panning
                SketchfabWrapper.api.setCameraLookAt( camera.position,Camera.panoLookat,0.01 );

            };
        });

    },

    SetCamera: function(api,eye,target){
        SketchfabWrapper.api.setCameraLookAt( eye,target,0.01 );
    },

    distanceVector: function( v1, v2 )
                    {
                        var dx = v1[0] - v2[0];
                        var dy = v1[1] - v2[1];
                        var dz = v1[2] - v2[2];

                        return Math.sqrt( dx * dx + dy * dy + dz * dz );
                    },

    cameraLoopOrbit: function () {
        Camera.EnforceMinCameraAngle(SketchfabWrapper.api);

        Camera.loopTimeoutIndex = setInterval(function() {
            Camera.EnforceMinCameraAngle(SketchfabWrapper.api);
        }, 50);
    },

    cameraLoopPano: function (distance, lookat) {
        Camera.LockPano(distance, lookat);

        Camera.loopTimeoutIndex = setInterval(function() {
            Camera.LockPano(distance, lookat);
        }, 50);
    }

};

export default Camera;


// WEBPACK FOOTER //
// ./src/js/lib/Camera.js